import { Error, Loader } from "@/components/display";
import { extractMessageFromError } from "@/shared/notification";
import { Stack, Typography } from "@mui/material";

const fullAbsolute = {
    position: "absolute",
    top: 0, bottom: 0, left: 0, right: 0,
} as const

export function DataTableLoader() {
    return <Loader {...fullAbsolute} />
}

export function DataTableError({ error }: { error: Error | boolean }) {
    const title = error ? extractMessageFromError(error) : "Hubo un error al cargar los datos";
    return <Error {...fullAbsolute} title={title} message={""} />
}

export function DataTableEmpty({ emptyText }: { emptyText: string }) {
    return <Stack {...fullAbsolute} justifyContent={"center"} alignItems={"center"}>
        <Typography variant="body2" color="text.secondary">{emptyText}</Typography>
    </Stack>
}